import { render } from "./AppMain.vue?vue&type=template&id=70b4d97e&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=ts"
export * from "./AppMain.vue?vue&type=script&lang=ts"

import "./AppMain.vue?vue&type=style&index=0&id=70b4d97e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-70b4d97e"

export default script